import { render } from "./LayoutQuestion.vue?vue&type=template&id=0607320d"
import script from "./LayoutQuestion.vue?vue&type=script&lang=ts"
export * from "./LayoutQuestion.vue?vue&type=script&lang=ts"

import "./LayoutQuestion.vue?vue&type=style&index=0&id=0607320d&lang=scss"
script.render = render

export default script